import { getChannelAudio } from '../utils/get-channel-audio';

import { useCurrentChannelStream } from './use-current-channel-stream';

export const useAudio = (contentId: string) => {
    const stream = useCurrentChannelStream(contentId);

    return getChannelAudio(stream);
};
